module.exports = __webpack_public_path__ + "static/media/logo-white.5c0a02e3.svg";